(function () {
  if (!window.HairoReviews) {
    window.HairoReviews = {
      parseDate: function (s) {
        s = (s || '').trim();
        var m = s.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/);
        if (m) return new Date(+m[1], +m[2] - 1, +m[3]).getTime();
        m = s.match(/^(\d{1,2})[-./](\d{1,2})[-./](\d{2,4})$/);
        if (m) { var y = +m[3]; if (y < 100) y += 2000; return new Date(y, +m[2] - 1, +m[1]).getTime(); }
        return 0;
      },
      init: function (root) {
        if (!root || root.dataset.hrvReady) return;
        root.dataset.hrvReady = '1';
        var H = window.HairoReviews;
        var $ = function (sel, el) { return (el || root).querySelector(sel); };
        var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

        /* ---------- List: sort + filter + load more ---------- */
        var list = $('[data-hrv-list]');
        var cards = $$('[data-hrv-card]', list);
        var initial = parseInt(root.dataset.initial, 10) || 6;
        var step = parseInt(root.dataset.step, 10) || 6;
        var shown = initial;
        var filter = 0;
        var order = cards.slice();
        var moreBtn = $('[data-hrv-more]');
        var sortBtn = $('[data-hrv-sortbtn]');
        var sortMenu = $('[data-hrv-sortmenu]');
        var dist = $('[data-hrv-dist]');
        var filterBtns = $$('[data-hrv-filter]');
        var filterBar = $('[data-hrv-filterbar]');

        function matching() { return order.filter(function (c) { return !filter || +c.dataset.rating === filter; }); }
        function render() {
          var vis = matching();
          order.forEach(function (c) { c.hidden = true; });
          vis.forEach(function (c, i) { c.hidden = i >= shown; });
          if (moreBtn) moreBtn.hidden = shown >= vis.length;
        }
        function setFilter(n) {
          filter = n;
          shown = initial;
          filterBtns.forEach(function (b) {
            var on = +b.dataset.hrvFilter === filter;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (dist) dist.classList.toggle('has-filter', !!filter);
          if (filterBar) {
            filterBar.hidden = !filter;
            if (filter) {
              $('[data-hrv-filtertext]', filterBar).textContent = (filterBar.dataset.template || '').replace('[stars]', filter).replace('[count]', matching().length);
            }
          }
          render();
        }
        function sortBy(key) {
          var d = function (c) { return H.parseDate(c.dataset.date); };
          var r = function (c) { return +c.dataset.rating; };
          var ix = function (c) { return +c.dataset.index; };
          var m = function (c) { return c.dataset.media === '1' ? 1 : 0; };
          order = cards.slice();
          if (key === 'newest') order.sort(function (a, b) { return d(b) - d(a) || ix(a) - ix(b); });
          else if (key === 'oldest') order.sort(function (a, b) { return d(a) - d(b) || ix(a) - ix(b); });
          else if (key === 'highest') order.sort(function (a, b) { return r(b) - r(a) || d(b) - d(a) || ix(a) - ix(b); });
          else if (key === 'lowest') order.sort(function (a, b) { return r(a) - r(b) || d(b) - d(a) || ix(a) - ix(b); });
          else order.sort(function (a, b) { return r(b) - r(a) || m(b) - m(a) || d(b) - d(a) || ix(a) - ix(b); });
          order.forEach(function (c) { list.appendChild(c); });
          if (sortMenu) $$('[data-sort]', sortMenu).forEach(function (b) { b.setAttribute('aria-checked', b.dataset.sort === key ? 'true' : 'false'); });
          shown = initial;
          render();
        }
        if (moreBtn) moreBtn.addEventListener('click', function () { shown += step; render(); });
        filterBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            var v = +b.dataset.hrvFilter;
            setFilter(filter === v ? 0 : v);
          });
        });
        if (filterBar) $('[data-hrv-filterclear]', filterBar).addEventListener('click', function () { setFilter(0); });
        if (sortBtn && sortMenu) {
          sortBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            sortMenu.hidden = !sortMenu.hidden;
            sortBtn.setAttribute('aria-expanded', String(!sortMenu.hidden));
          });
          $$('[data-sort]', sortMenu).forEach(function (b) {
            b.addEventListener('click', function () { sortBy(b.dataset.sort); sortMenu.hidden = true; sortBtn.setAttribute('aria-expanded', 'false'); });
          });
          document.addEventListener('click', function (e) { if (!sortMenu.hidden && !sortMenu.contains(e.target)) { sortMenu.hidden = true; sortBtn.setAttribute('aria-expanded', 'false'); } });
        }
        sortBy(root.dataset.defaultSort || 'recommended');

        /* Theme editor: reveal a selected review even if it's hidden */
        document.addEventListener('shopify:block:select', function (e) {
          var card = e.target && e.target.closest && e.target.closest('[data-hrv-card]');
          if (!card || !root.contains(card)) return;
          if (filter && +card.dataset.rating !== filter) setFilter(0);
          var pos = matching().indexOf(card);
          if (pos >= shown) { shown = pos + 1; render(); }
        });

        /* ---------- Lightbox ---------- */
        var lb = $('[data-hrv-lightbox]');
        var lbTrack = $('[data-hrv-lb-track]');
        function closeLb() { lb.hidden = true; lbTrack.innerHTML = ''; document.documentElement.style.overflow = ''; }
        $$('[data-hrv-open-media]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var tpl = btn.parentNode.querySelector('template[data-hrv-media]');
            if (!tpl) return;
            lbTrack.innerHTML = '';
            lbTrack.appendChild(tpl.content.cloneNode(true));
            lb.hidden = false;
            document.documentElement.style.overflow = 'hidden';
          });
        });
        $('[data-hrv-lb-close]').addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('hrv-lightbox__item')) closeLb(); });

        /* ---------- Write a review ---------- */
        var modal = $('[data-hrv-modal]');
        var form = $('[data-hrv-form]');
        var nextBtn = $('[data-hrv-next]');
        var backBtn = $('[data-hrv-back]');
        var bars = $$('.hrv-progress span');
        var progress = $('.hrv-progress');
        var steps = $$('[data-step]', form);
        var rateWrap = $('[data-hrv-rate]');
        var rateBtns = $$('button', rateWrap);
        var ratingInput = $('[data-hrv-rating-input]');
        var textEl = $('[data-hrv-text]');
        var filesWrap = $('[data-hrv-files]');
        var previews = $('[data-hrv-previews]');
        var fileErr = $('[data-hrv-file-err]');
        var formErr = $('[data-hrv-form-err]');
        var maxBytes = (parseFloat(root.dataset.maxMb) || 10) * 1024 * 1024;
        var maxImages = parseInt(root.dataset.maxImages, 10) || 4;
        var current = 1, rating = 0, fileSeq = 0, sending = false;

        function paintStars(n) { rateBtns.forEach(function (b, i) { b.classList.toggle('is-on', i < n); }); }
        function fileInputs() { return $$('input[type=file]', filesWrap).filter(function (i) { return i.files && i.files.length; }); }
        function totalSize() { return fileInputs().reduce(function (s, i) { return s + i.files[0].size; }, 0); }

        function go(n) {
          current = n;
          steps.forEach(function (s) { s.hidden = +s.dataset.step !== n; });
          bars.forEach(function (b, i) { b.classList.toggle('is-on', i < Math.min(n, 4)); });
          backBtn.style.visibility = (n > 1 && n < 5) ? 'visible' : 'hidden';
          progress.style.visibility = n < 5 ? 'visible' : 'hidden';
          updateNext();
          form.scrollTop = 0;
        }
        function updateNext() {
          var d = nextBtn.dataset;
          nextBtn.classList.remove('is-link');
          nextBtn.disabled = false;
          if (current === 1) { nextBtn.textContent = d.labelNext; nextBtn.disabled = !rating; }
          else if (current === 2) {
            if (fileInputs().length) nextBtn.textContent = d.labelNext;
            else { nextBtn.textContent = d.labelSkip; nextBtn.classList.add('is-link'); }
          }
          else if (current === 3) { nextBtn.textContent = d.labelNext; nextBtn.disabled = !textEl.value.trim(); }
          else if (current === 4) { nextBtn.textContent = sending ? d.labelSending : d.labelFinish; nextBtn.disabled = sending; }
          else { nextBtn.textContent = d.labelClose; }
        }
        function open(atStep) {
          modal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          go(atStep || 1);
        }
        function close() {
          modal.hidden = true;
          document.documentElement.style.overflow = '';
          if (current === 5) reset();
        }
        function reset() {
          rating = 0; paintStars(0); ratingInput.value = '';
          textEl.value = ''; filesWrap.innerHTML = ''; previews.innerHTML = '';
          fileErr.textContent = ''; formErr.textContent = '';
          $$('[data-hrv-req]', form).forEach(function (i) { i.value = ''; i.classList.remove('is-invalid'); });
          var ln = form.querySelector('[name="שם משפחה"]'); if (ln) ln.value = '';
        }

        $$('[data-hrv-open-form]').forEach(function (b) { b.addEventListener('click', function () { open(1); }); });
        $('[data-hrv-close]').addEventListener('click', close);
        modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          if (!lb.hidden) closeLb(); else if (!modal.hidden) close();
        });
        window.addEventListener('pageshow', function () { if (sending) { sending = false; updateNext(); } });

        /* Stars */
        rateBtns.forEach(function (b) {
          var v = +b.dataset.value;
          b.addEventListener('mouseenter', function () { paintStars(v); });
          b.addEventListener('focus', function () { paintStars(v); });
          b.addEventListener('click', function () {
            rating = v; ratingInput.value = v + ' / 5'; paintStars(v); updateNext();
            setTimeout(function () { if (current === 1) go(2); }, 260);
          });
        });
        rateWrap.addEventListener('mouseleave', function () { paintStars(rating); });

        /* Files */
        $$('[data-hrv-add-file]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            fileErr.textContent = '';
            var kind = btn.dataset.hrvAddFile;
            var existing = fileInputs().filter(function (i) { return i.dataset.kind === kind; }).length;
            if (kind === 'image' && existing >= maxImages) { fileErr.textContent = 'אפשר להעלות עד ' + maxImages + ' תמונות.'; return; }
            if (kind === 'video' && existing >= 1) { fileErr.textContent = 'אפשר להעלות סרטון אחד.'; return; }
            $$('input[type=file]', filesWrap).forEach(function (i) { if (!i.files || !i.files.length) i.remove(); });
            fileSeq += 1;
            var inp = document.createElement('input');
            inp.type = 'file';
            inp.name = fileSeq === 1 ? 'attachment' : 'attachment' + fileSeq;
            inp.accept = kind === 'image' ? 'image/*' : 'video/*';
            inp.dataset.kind = kind;
            filesWrap.appendChild(inp);
            inp.addEventListener('change', function () {
              if (!inp.files || !inp.files.length) { inp.remove(); return; }
              var f = inp.files[0];
              if (totalSize() > maxBytes) {
                fileErr.textContent = 'הקבצים גדולים מדי. הגודל הכולל המקסימלי הוא ' + root.dataset.maxMb + ' מגה. נסו סרטון קצר יותר או פחות תמונות.';
                inp.remove(); updateNext(); return;
              }
              var p = document.createElement('div');
              p.className = 'hrv-prev';
              var url = URL.createObjectURL(f);
              if (kind === 'image') { var im = document.createElement('img'); im.src = url; im.alt = ''; p.appendChild(im); }
              else { var vd = document.createElement('video'); vd.src = url; vd.muted = true; vd.playsInline = true; vd.preload = 'metadata'; p.appendChild(vd); }
              var rm = document.createElement('button');
              rm.type = 'button'; rm.setAttribute('aria-label', 'הסרה');
              rm.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
              rm.addEventListener('click', function () { inp.remove(); p.remove(); URL.revokeObjectURL(url); fileErr.textContent = ''; updateNext(); });
              p.appendChild(rm);
              previews.appendChild(p);
              updateNext();
            });
            inp.click();
          });
        });

        textEl.addEventListener('input', updateNext);

        /* Navigation */
        backBtn.addEventListener('click', function () { if (current > 1 && current < 5) go(current - 1); });
        nextBtn.addEventListener('click', function () {
          if (current < 4) { go(current + 1); return; }
          if (current === 5) { close(); return; }
          submit();
        });

        function submit() {
          formErr.textContent = '';
          var ok = true;
          $$('[data-hrv-req]', form).forEach(function (i) {
            var bad = !i.value.trim();
            if (!bad && i.hasAttribute('data-hrv-email')) bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim());
            i.classList.toggle('is-invalid', bad);
            if (bad) ok = false;
          });
          if (!ok) { formErr.textContent = 'נא למלא את כל שדות החובה (שם פרטי, מייל תקין ומספר הזמנה).'; return; }
          if (!form.getAttribute('action')) { formErr.textContent = 'הטופס עדיין לא מחובר. נסו שוב מאוחר יותר.'; return; }
          $$('input[type=file]', filesWrap).forEach(function (i) { if (!i.files || !i.files.length) i.remove(); });
          var fn = form.querySelector('[name="שם פרטי"]').value.trim();
          $('[data-hrv-subject]').value = (nextBtn.dataset.subject || 'ביקורת חדשה') + ' | ' + rating + ' כוכבים | ' + fn;
          var here = new URL(window.location.href);
          here.hash = '';
          $('[data-hrv-page-url]').value = here.toString();
          here.searchParams.set('hrv_sent', root.id);
          here.hash = root.id;
          $('[data-hrv-next-url]').value = here.toString();
          sending = true; updateNext();
          form.submit();
        }

        /* Returned from a successful submission */
        try {
          var params = new URLSearchParams(window.location.search);
          if (params.get('hrv_sent') === root.id) {
            params.delete('hrv_sent');
            var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
            window.history.replaceState(null, '', clean);
            open(5);
          }
        } catch (e) {}
      }
    };
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector && e.target.querySelector('[data-hrv-root]');
      if (r) window.HairoReviews.init(r);
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-hrv-root]'), function (r) { window.HairoReviews.init(r); });
})();